import { Col, message, Row } from 'antd';
import classNames from 'classnames';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { putFileKey } from '../../apis/file';
import Box from '../../components/box2.jsx';
import ImgDialog from '../../components/imgDialog.jsx';
import Loading from '../../components/loading.jsx';
import style from './brand2.module.scss';

function ImageItem({ className = '', title, url, onClick }) {
  function onImgClick() {
    onClick && onClick(url);
  }

  return (
    <div className={className}>
      {title && <div className={style.imageItemTitle}>{title}</div>}
      <div className={style.imageItemContent} onClick={onImgClick}>
        <img src={url} alt={title} />
      </div>
    </div>
  );
}

function Legned({ className = '' }) {
  return (
    <div className={classNames(style.legend, className)}>
      <div className={style.legend1}></div>
      <div className={style.legend2}>
        <div className={style.legend21}>1%</div>
        <div className={style.legend21}>20%</div>
        <div className={style.legend21}>40%</div>
        <div className={style.legend21}>60%</div>
        <div className={style.legend21}>80%</div>
        <div className={style.legend21}>100%</div>
      </div>
    </div>
  );
}

function PackageAiBody({ useNextBtn, context: ctx }) {
  // image
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const data12 = useMemo(() => {
    return data1.concat(data2);
  }, [data1, data2]);

  // heatmap
  const [data3, setData3] = useState([]);

  const [loading, setLoading] = useState(true);
  async function init() {
    try {
      // use pacakage info
      const pp = ctx?.res?.predictPackage;
      if (!pp) return;
      const variants = ctx?.res?.variants;
      if (!variants) return;
      const list = [];
      const list2 = [];
      const list3 = [];

      const processValue = async (name, fileKey) => {
        if (!fileKey) return;
        const { data } = await putFileKey(fileKey);
        list.push({ title: name, url: data.url });
      };
      const processValue2 = async (name, fileKey) => {
        if (!fileKey) return;
        const { data } = await putFileKey(fileKey);
        list2.push({ title: name, url: data.url });
      };
      const processValue3 = async (name, fileKey) => {
        if (!fileKey) return;
        const { data } = await putFileKey(fileKey);
        list3.push({ title: name, url: data.url });
      };

      // ul brand
      const uld0v = variants[pp.ul_design0_variant0_id];
      const uld0vTitle = `${pp.brand_ul} Current`;
      await processValue(uld0vTitle, uld0v?.sequenceimage);
      await processValue3(uld0vTitle, uld0v?.heatmapimage);
      const uld1v = variants[pp.ul_design1_variant0_id];
      const uld1vTitle = `${pp.brand_ul} New Design`;
      await processValue(uld1vTitle, uld1v?.sequenceimage);
      await processValue3(uld1vTitle, uld1v?.heatmapimage);
      const uld2v = variants[pp.ul_design2_variant0_id];
      const uld2vTitle = `${pp.brand_ul} New Design 2`;
      await processValue(uld2vTitle, uld2v?.sequenceimage);
      await processValue3(uld2vTitle, uld2v?.heatmapimage);
      const uld3v = variants[pp.ul_design3_variant0_id];
      const uld3vTitle = `${pp.brand_ul} New Design 3`;
      await processValue(uld3vTitle, uld3v?.sequenceimage);
      await processValue3(uld3vTitle, uld3v?.heatmapimage);
      setData1(list);
      setData3(list3);
      // c1 brand
      const c1d1v = variants[pp.c1_design1_variant0_id];
      const c1d1vTitle = `${pp.brand_c1}`;
      await processValue2(c1d1vTitle, c1d1v?.sequenceimage);
      await processValue3(c1d1vTitle, c1d1v?.heatmapimage);
      // c2 brand
      const c2d1v = variants[pp.c2_design1_variant0_id];
      const c2d1vTitle = `${pp.brand_c2}`;
      await processValue2(c2d1vTitle, c2d1v?.sequenceimage);
      await processValue3(c2d1vTitle, c2d1v?.heatmapimage);
      setData2(list2);
      setData3([...list3]);
    } catch (err) {
      console.error('init error', err);
      message.error('Failed to load data');
    }
    setLoading(false);
  }
  useEffect(() => {
    void init();
  }, [ctx]);

  const [dialogVisible, setDialogVisible] = useState(false);
  const [dialogImageIndex, setDialogImageIndex] = useState(0);
  const dialogImageUrl = useMemo(() => {
    return data12[dialogImageIndex]?.url;
  }, [data12, dialogImageIndex]);
  const onDialogNext = useCallback(() => {
    setDialogImageIndex((i) => {
      if (i >= data12.length - 1) return 0;
      return i + 1;
    });
  }, [setDialogImageIndex, data12]);
  const onDialogPrev = useCallback(() => {
    setDialogImageIndex((i) => {
      if (i <= 0) return data12.length - 1;
      return i - 1;
    });
  }, [setDialogImageIndex, data12]);

  /**
   * on image click
   * @param {number} index
   */
  function onImgClick(index) {
    setDialogVisible(true);
    setDialogImageIndex(index);
  }

  // Dialog for heatmap images (data3)
  const [heatmapDialogVisible, setHeatmapDialogVisible] = useState(false);
  const [heatmapDialogImageIndex, setHeatmapDialogImageIndex] = useState(0);
  const heatmapDialogImageUrl = useMemo(() => {
    return data3[heatmapDialogImageIndex]?.url;
  }, [data3, heatmapDialogImageIndex]);

  const onHeatmapDialogNext = useCallback(() => {
    setHeatmapDialogImageIndex((i) => {
      if (i >= data3.length - 1) return 0;
      return i + 1;
    });
  }, [setHeatmapDialogImageIndex, data3]);

  const onHeatmapDialogPrev = useCallback(() => {
    setHeatmapDialogImageIndex((i) => {
      if (i <= 0) return data3.length - 1;
      return i - 1;
    });
  }, [setHeatmapDialogImageIndex, data3]);

  /**
   * on heatmap image click
   * @param {number} index
   */
  function onHeatmapImgClick(index) {
    setHeatmapDialogVisible(true);
    setHeatmapDialogImageIndex(index);
  }

  return (
    <div className={style.box1}>
      {loading && <Loading />}
      <Row gutter={25}>
        <Col span={10}>
          <div className={style.box1Title}>Individual Heatmap</div>
          <div className={style.box121}>
            {data3.map((item, index) => {
              return (
                <ImageItem
                  key={`${item.title}-${index}`}
                  className={style.box121Item}
                  title={item.title}
                  url={item.url}
                  onClick={() => onHeatmapImgClick(index)}
                />
              );
            })}
          </div>
          <Legned className={style.box122} />
          <Box className={style.box123}>
            <div className={style.box1231}>
              The Heatmap helps identify which areas of your package are
              grabbing the most attention; the probability that areas(s) will be
              noticed within the first 3-5 seconds of seeing the image.
              Technically it comes from aggregating gaze points or fixations
              from many users and visualizes them with color intensity.&nbsp;
              <span className={style.tip}>Pro Tips: </span>
              Heatmap results can show you what is attracting, and distracting,
              attention within the visual content.
            </div>
          </Box>
        </Col>
        <Col span={10}>
          <div className={style.box1Title}>Visual Hierarchy</div>
          <div className={style.box111}>
            {data12.map((item, index) => {
              return (
                <ImageItem
                  key={`${item.title}-${index}`}
                  className={style.box111Item}
                  title={item.title}
                  url={item.url}
                  onClick={() => onImgClick(index)}
                />
              );
            })}
          </div>
          <Box className={style.box112}>
            <div className={style.box1121}>
              The gaze sequence indicates the four most likely locations a
              person will glance, in the probable viewing order, within the
              first 3-5 seconds.
              <br />
              <span className={style.tip}>Pro Tips: </span>
              Use the gaze sequence to see if the predicted viewer attention
              aligns with your intended visual hierarchy or goals.
            </div>
          </Box>
        </Col>
        <Col span={4}>
          <Box>
            <div className={style.box131}>
              <div className={style.box1311}>
                THE OPTIMAL DESIGN HIERARCHY (based on Metrixlab Meta Learnings)
              </div>
              <ul className={style.box1312}>
                <li>brand</li>
                <li>variant</li>
                <li>RTB</li>
                <li>emotive promise visualization</li>
                <li>pack content</li>
                <li>call-to-action</li>
              </ul>
            </div>
          </Box>
          {useNextBtn && useNextBtn({ className: style.btnBox })}
        </Col>
      </Row>
      <ImgDialog
        visible={dialogVisible}
        setVisible={setDialogVisible}
        src={dialogImageUrl}
        onPrev={onDialogPrev}
        onNext={onDialogNext}
      />
      <ImgDialog
        visible={heatmapDialogVisible}
        setVisible={setHeatmapDialogVisible}
        src={heatmapDialogImageUrl}
        onPrev={onHeatmapDialogPrev}
        onNext={onHeatmapDialogNext}
      />
    </div>
  );
}

export default PackageAiBody;
